import request from '@/utils/request'



// 获取评论列表API
export const getGiftRate = (params) => {
  return request({
    url: `/setting/gift/rate`,
    method: 'get',
    params
  })
}


// 获取评论列表API
export const updateGiftRate = (data) => {
  return request({
    url: `/setting/gift/rate`,
    method: 'post',
    data
  })
}

// 礼物记录分页
export const getGiftRecordPage = (params) => {
  return request({
    url: `/user/gift/record/page`,
    method: 'get',
    params
  })
}